//SET LOADING STATE

export const setLoadingIndicator = (isLoadingData) => ({
    type : 'SET_LOADING_INDICATOR',
    isLoadingData
});

export const setNoSelectFilter = (noSelected) => ({
    type : 'NO_SELECT_ERROR',
    noSelected
});
export const setNoCheckBoxSelectedFilter = (noCheckbox) => ({
    type : 'NO_CHECKBOX_SELECTED_ERROR',
    noCheckbox
});


// WEBPACK FOOTER //
// ./src/Actions/loading.js